import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import injectTapEventPlugin from 'react-tap-event-plugin';
import 'react-mdl/extra/material.css';
import firebase from 'firebase';
import ReactGA from 'react-ga';

// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
injectTapEventPlugin();

// Google Analytics
ReactGA.initialize('UA-88911926-2', { debug: false });

// Initialize Firebase
var config = {
  apiKey: "AIzaSyBTNiwNxsizYGLL1FxvG2WsL4GcA7sqjHE",
  authDomain: "pepperly-78.firebaseapp.com",
  databaseURL: "https://pepperly-78.firebaseio.com",
  storageBucket: "pepperly-78.appspot.com",
  messagingSenderId: "187858483165"
};
firebase.initializeApp(config);

ReactDOM.render(
  <App />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js